// extracted by mini-css-extract-plugin
module.exports = {"timer":"Time_timer__2IVcp","indicator":"Time_indicator__1qJUq","rec":"Time_rec__21cjj","blinking":"Time_blinking__3VB8j"};